'use client';

import { useEffect } from 'react';
import { screensizeStore } from './store';

export const WindowSizeListener = () => {
  useEffect(() => {
    const resizeHandler = () => {
      screensizeStore.getState().recalculateBreakpointValues();
    };
    window.addEventListener('resize', resizeHandler);
    resizeHandler();

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return null;
};
